module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0001.jpg?v=296be186";